export function receiveNumberFormatWithMilhar(number: number | any): string {
    return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
